/* eslint-disable */
export default {
  tollFree: 'Línea gratuita',
  rcvPmiMeetingTitle: 'Reunión por video de {extensionName}',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
